/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { sendEmail } from 'apis/groundingApis'
import { DocumentType, DocumentTypeEnum, SessionStorageKey } from 'common/constants'
import { Rules } from 'common/rules'
import DividerWidthText from 'components/Grounding/DividerWidthText'
import GroundingVehicleDetails from 'components/Grounding/GroundingVehicleDetails'
import { Formik, useFormik } from 'formik'
import { useEffect, useRef, useState } from 'react'
import { Alert, Button, Col, Form, InputGroup, Row } from 'react-bootstrap'
import { useGlobalStore } from 'store/useGlobalStore'
import { IEmailRtn } from 'types/Grounding/GroundingRequest'
import { downloadURI } from 'utils/exportFileUtil'
import * as Yup from 'yup'
import { OverlayLoader } from 'components/Loader'
import BarcodeScannerIcon from 'icons/BarcodeScannerIcon'
import { checkCamera } from 'utils/cameraUtils'
import { AlertDialog } from 'components/AlertDialog/AlertDialog'
import ScanVIN from 'components/Grounding/ScanVIN'
import { useHistory } from 'react-router-dom'
import shallow from 'zustand/shallow'
import StyleGroundingResults, { StyleGroundingResult } from './GroundingResult.styled'
import { useGroundingStore } from './store/useGroundingStore'
import { useDtmAnalytics } from 'hooks/useDtmAnalytics'

interface MessageType {
  content: string
  type: string
}
interface IDocumentType {
  id?: number
  description?: string
}
interface DocumentFormProps {
  docType?: IDocumentType
  VIN: string
  vehicleInstanceId: number
  allowOffer?: boolean
  showMakeOfferOrPurchase?: boolean
  isPurchase?: boolean
  setSuccess: () => void
  setError: (message: string) => void
}

const GroundingResult = () => {
  const history = useHistory()
  const { userInteraction } = useDtmAnalytics()
  const [groundingData] = useGroundingStore((state) => [state.groundingData], shallow)
  const [isInRule] = useGlobalStore((state) => [state.isInRule], shallow)
  const [isLoading, setIsLoading] = useState(false)

  const [showMessage, setShowMessage] = useState(false)
  const [showVehMandatory, setShowVehMandatory] = useState(groundingData?.isVehicleMandatory)
  const [message, setMessage] = useState<MessageType>({
    content: '',
    type: 'success'
  })
  const [hasSaveGroundingError, setHasSaveGroundingError] = useState(false)
  const scanButtonRef = useRef<HTMLButtonElement>(null)
  const [cameraError, setCameraError] = useState('')
  const [showScanner, setShowScanner] = useState(false)
  const [modalShow, setModalShow] = useState(false)

  const isPurchase =
    groundingData?.purchasePriceString !== undefined &&
    groundingData?.purchasePriceString !== null &&
    groundingData?.purchasePriceString !== '' &&
    groundingData?.performPurchase === true
  const allowPurchase = isInRule(Rules.VIEW_DASHBOARD_GROUNDING_STATUS)
  const showMakeOfferOrPurchase =
    allowPurchase &&
    groundingData?.paymentTypes.length > 0 &&
    (groundingData?.purchasePriceString === undefined || groundingData?.purchasePriceString !== '$0') &&
    !isPurchase &&
    groundingData?.canPurchaseVehicleInGESaleChannel

  useEffect(() => {
    window.sessionStorage.removeItem(SessionStorageKey.GROUND_VIN)
    if (groundingData?.ErrorMessage !== '' && groundingData?.ErrorMessage !== undefined) {
      handleMessage(false, groundingData?.ErrorMessage)
      setHasSaveGroundingError(true)
    }
  }, [])

  const handleMessage = (status: boolean, content: string = 'Email Sent') => {
    if (status) {
      setMessage({
        content,
        type: 'success'
      })
      setShowMessage(true)
      return
    }
    setMessage({
      content,
      type: 'danger'
    })
    setShowMessage(true)
  }

  const SubmitGrounding = async (values) => {
    userInteraction('Grounding: Ground Another')
    sessionStorage.setItem(SessionStorageKey.GROUND_VIN, values.vin)
    window.location.href = '/grounding'
  }

  const schema = Yup.object({
    vin: Yup.string().length(17, 'Must be 17 characters').required('Required')
  })

  const redirectToCamera = async () => {
    try {
      setCameraError('')
      const hasCamera = await checkCamera()

      if (hasCamera) {
        // On mobile, it's better to have a small delay before showing the scanner
        // This helps with the fullscreen API which often requires a user gesture
        setTimeout(() => {
          setShowScanner(true)
        }, 100)
      } else {
        setCameraError('No camera detected or permission denied')
        setModalShow(true)
      }
    } catch (error) {
      console.error('Camera access error:', error)
      setCameraError('Error accessing camera: ' + (error.message || 'Unknown error'))
      setModalShow(true)
    }
  }

  const handleScanComplete = (scannedVin: string | null) => {
    setShowScanner(false)
    if (scannedVin) {
      sessionStorage.setItem(SessionStorageKey.GROUND_VIN, scannedVin)
      window.location.href = '/grounding'
    }
  }

  return (
    <StyleGroundingResults>
      <AlertDialog
        title="Camera Access Error"
        description={cameraError || 'Please allow camera access to use this feature'}
        show={modalShow}
        onHide={() => setModalShow(false)}
        isConfirmation={false}
      />
      {showScanner && <ScanVIN onComplete={handleScanComplete} />}
      {isLoading && <OverlayLoader />}
      <GroundingVehicleDetails />
      <StyleGroundingResult>
        <p>Grounding Completion Date: {groundingData?.groundingDate}</p>
        <DividerWidthText title="Ground Completion" />
        {!hasSaveGroundingError && (
          <h2 className="title-result mt-4">
            VIN {groundingData?.VIN} has been successfully grounded {isPurchase ? 'and purchased' : ''}
          </h2>
        )}
        {showVehMandatory && (
          <Alert className="col-10 mt-4" variant="danger" onClose={() => setShowVehMandatory(false)} dismissible>
            {groundingData?.MandatoryOrEligible}
          </Alert>
        )}
        <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {showMessage && (
            <Alert className="col-10 mt-4" variant={message?.type} onClose={() => setShowMessage(false)} dismissible>
              {message?.content}
            </Alert>
          )}
        </Row>
        {!hasSaveGroundingError && (
          <Row>
            <Col sm="12">
              <div className="document-form">
                {groundingData?.VehicleDocuments?.map((e) => (
                  <DocumentForm
                    VIN={groundingData.VIN}
                    vehicleInstanceId={groundingData?.vehicleInstanceID}
                    docType={DocumentType.find((doc) => doc.id === e.DocumentTypeID)}
                    isPurchase={
                      (isPurchase && e?.DocumentTypeID === DocumentTypeEnum.PURCHASE) ||
                      e?.DocumentTypeID !== DocumentTypeEnum.PURCHASE
                    }
                    allowOffer={groundingData?.AllowOffer}
                    showMakeOfferOrPurchase={showMakeOfferOrPurchase}
                    setSuccess={() => {
                      handleMessage(true)
                    }}
                    setError={(message) => {
                      handleMessage(false, message)
                    }}
                    key={e.ID}
                  />
                ))}
              </div>
            </Col>
          </Row>
        )}
        <Row>
          <Col sm="12">
            <DividerWidthText title="Ground another vehicle?" />
            <Formik
              initialValues={{
                vin: ''
              }}
              validationSchema={schema}
              onSubmit={SubmitGrounding}
            >
              {(props) => (
                <Form onSubmit={props.handleSubmit} onReset={props.handleReset}>
                  <Row>
                    <Form.Group className="ground-another-vin" as={Col} sm="6" lg="4">
                      <Form.Label>Enter VIN</Form.Label>
                      <Col>
                        <InputGroup>
                          <Form.Control
                            type="input"
                            name="vin"
                            placeholder="#17 digit VIN"
                            onChange={props.handleChange}
                            onBlur={props.handleBlur}
                            value={props.values.vin}
                            isInvalid={!!props.errors.vin}
                          />
                          <InputGroup.Append>
                            <Button
                              className="search-option-scan-btn"
                              variant=""
                              onClick={redirectToCamera}
                              ref={scanButtonRef}
                            >
                              <BarcodeScannerIcon />
                              <label>SCAN</label>
                            </Button>
                          </InputGroup.Append>
                        </InputGroup>
                        <Form.Control.Feedback tooltip={false} type="invalid">
                          {props.errors.vin}
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                    <Form.Group className="col-lg-4 col-sm-4 pl-0">
                      <Button
                        variant="primary"
                        disabled={!(props.isValid && props.dirty)}
                        type="submit"
                        className="mx-2"
                      >
                        GROUND
                      </Button>
                      <Button className="btn-secondary" type="reset">
                        CLEAR ALL
                      </Button>
                    </Form.Group>
                  </Row>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      </StyleGroundingResult>
    </StyleGroundingResults>
  )
}

const DocumentForm = ({
  VIN,
  vehicleInstanceId,
  docType,
  isPurchase,
  allowOffer,
  showMakeOfferOrPurchase,
  setSuccess,
  setError
}: DocumentFormProps) => {
  const { userInteraction } = useDtmAnalytics()

  const handleSendEmail = async (value) => {
    const req: IEmailRtn = {
      VIN: VIN,
      documentType: docType.id,
      emailList: value.email
    }
    if (value.email === '') {
      return setError('You must enter one or more email address(es)')
    }
    userInteraction('Grounding: Send Email', [{ VIN }])
    const response = await sendEmail(req)
    if (response === '') {
      setSuccess()
    } else {
      setError(response)
    }
    value.email = ''
  }

  const formik = useFormik({
    initialValues: {
      email: ''
    },
    onSubmit: handleSendEmail
  })

  const handleUrl = (id) => {
    userInteraction('Grounding: Download PDF', [{ VIN }])
    const url = '/resource/GetGroundingPDFByVIN?VIN=' + VIN + '&type=' + id
    downloadURI(url)
  }

  return (
    <>
      {isPurchase && (
        <Form className="mb-4" onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
          <Row>
            <Form.Group as={Col} sm="12" lg="5">
              <Row className="justify-content-around">
                <Col sm="6" lg="6">
                  <p className="mb-4" style={{ fontSize: '16px' }}>
                    Get a copy of the {docType?.description}?
                  </p>
                </Col>
                <Col sm="3" lg="3" style={{ marginLeft: '13px' }}>
                  <Button
                    onClick={() => {
                      handleUrl(docType?.id)
                    }}
                    className="download-btn"
                  >
                    DOWNLOAD PDF
                  </Button>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group as={Col} sm="12" lg="7">
              <Row className="justify-content-center">
                <Col className="email-input" sm="2" lg="1">
                  <Form.Label>Email</Form.Label>
                </Col>
                <Form.Group as={Col} sm="6" lg="6">
                  <InputGroup>
                    <Form.Control
                      id="email"
                      name="email"
                      type="email"
                      onChange={formik.handleChange}
                      value={formik.values.email}
                      className="border document-input"
                    />
                  </InputGroup>

                  <small className="small-label" style={{ fontSize: '12px' }}>
                    Enter multiple email address separated by a semicolon
                  </small>
                </Form.Group>
                <Form.Group as={Col} sm="2" lg="2">
                  <Button className="send-button" variant="primary" type="submit">
                    SEND
                  </Button>
                </Form.Group>
              </Row>
            </Form.Group>
          </Row>
        </Form>
      )}
      {showMakeOfferOrPurchase && (
        <>
          <DividerWidthText
            title={`Purchase ${
              allowOffer !== undefined && allowOffer === true ? 'or Make an Offer on' : ''
            } this Vehicle?`}
          />
          <div style={{ marginBottom: '28px' }}>
            <Button
              href={'../vehicles#purchaseExclusive/' + vehicleInstanceId}
              variant="primary"
              style={{ marginLeft: '10px' }}
            >
              PURCHASE
            </Button>

            {allowOffer !== undefined && allowOffer === true && (
              <Button
                href={'../vehicles#MakeAnOffer/' + vehicleInstanceId}
                variant="primary"
                style={{ marginLeft: '10px' }}
              >
                MAKE OFFER
              </Button>
            )}
          </div>
        </>
      )}
    </>
  )
}

export default GroundingResult
